import React from "react";
import Button from "../../buttons/Button";
import { buildUrl } from "../../utils/helper";

/**
 * File cell
 * @module
 * @param {func} onClick - Function invoked on click
 */
export const fileCell = ({ onClick }) => {
  const FileCell = (props) => {
    const { field, dataItem, tdProps } = props;
    // const total = products.reduce((acc, current) => acc + current[props.field], 0);
    return (
      <td {...tdProps}>
        <Button onClick={() => onClick(field, dataItem)} primary={true} imageUrl={buildUrl("assets/icons/notify_priloha.svg")} title="Priloha" />
      </td>
    );
  };
  return FileCell
};
